import md5 from 'md5';
import { cookies } from '@binanceus/utils';
import { gwPost } from '../actions/actionsFactory/gwRequest';
import API_PATH from '../actions/actionsFactory/apiPath';
import { handleUserInfo } from '../actions/actionsSet/account';
import actions from '../actions/types';

const serverHeader = cookie => {
  const cr00 = cookies.read('cr00', { cookie });
  const csrftoken = md5(cr00);

  return {
    headers: {
      csrftoken,
      cookie,
    },
  };
};

// eslint-disable-next-line import/prefer-default-export
export async function auth(req, dispatch) {
  try {
    // init ssr login status
    if (req?.cookies?.logined === 'y') {
      const result = await gwPost(
        API_PATH.USER_INFO_API_PATH,
        {
          options: {
            withClientApiCache: true,
            isExpiredFromResponse: true,
          },
        },
        serverHeader(req.headers.cookie)
      );

      const data = handleUserInfo(result);

      if (data) {
        dispatch({ type: actions.USER_STATE_LOGGED_IN });
        dispatch({ type: actions.SET_USER_INFO, data });
      }
    }
  } catch (error) {
    console.log(error);
  }
}
